import { Component, OnInit }  from '@angular/core';
import { Router }             from '@angular/router';
import { CountryService } from '../../services/country/country.service';
import { DoctorService } from '../../services/doctors/doctor.service';
import { ProviderService } from '../../services/providers/provider.service';
import { SpecialtiesService } from '../../services/specialties/specialties.service';


enum gViewState {
    ALL,
    AVAILABLE,
    IN_CALL
}

@Component({
  selector: 'app-doctors-status',
  templateUrl: 'doctor-status.component.html',
  styleUrls: [ 'doctor-status.component.css', '../../users/detail/user-detail.component.css' ]
})

export class DoctorsStatusComponent implements OnInit {

    doctorsToShow;
    doctorsToShowCount;
    isLadDoctor:boolean = true;

    providers: any[];
    providerFilterEmptyItemText:string="All providers";
    providerFilter:any = -1;

    countries: any[];
    priorityCountryFilterEmptyItemText:string="All countries";
    priorityCountryFilter:any = -1;

    specialties: any[];
    specialtyFilterEmptyItemText:string="All specialties";
    specialtyFilter:any = -1;

    ViewState = gViewState;
    validationViews = [ this.ViewState.ALL, this.ViewState.AVAILABLE, this.ViewState.IN_CALL ]
    viewState = this.ViewState.ALL;

    constructor(
        protected router: Router,
        protected doctorService: DoctorService,
        protected providerService: ProviderService,
        protected countryService:CountryService,
        protected specialtiesService:SpecialtiesService,) { }

    ngOnInit(): void {
        this.getData();
        this.getProviders();
        this.getCountries();
        this.getSpecialties();
    }

    getData(): void {
        let provider = (!this.providerFilter || this.providerFilter == -1) ? "" : this.providerFilter;
        let priorityCountry = (!this.priorityCountryFilter || this.priorityCountryFilter == -1) ? "" : this.priorityCountryFilter;
        let specialty = (!this.specialtyFilter || this.specialtyFilter == -1) ? "" : this.specialtyFilter;
        switch (this.viewState) {
            case this.ViewState.ALL:
                this.doctorService.getStatus({
                    ladDoctor:this.isLadDoctor,
                    provider: provider,
                    priorityCountry: priorityCountry,
                    specialty: specialty
                    }).then(doctors=>{
                    this.doctorsToShow = doctors.available.concat(doctors.in_call)
                    this.doctorsToShowCount = this.doctorsToShow.length;
                })
                break;

            case this.ViewState.AVAILABLE:
                this.doctorService.getStatus({
                    ladDoctor:this.isLadDoctor,
                    provider: provider,
                    priorityCountry: priorityCountry,
                    specialty: specialty
                    }).then(doctors=>{
                    this.doctorsToShow = doctors.available
                    this.doctorsToShowCount = this.doctorsToShow.length;
                })
                break;

            case this.ViewState.IN_CALL:
                this.doctorService.getStatus({
                    ladDoctor:this.isLadDoctor,
                    provider: provider,
                    priorityCountry: priorityCountry,
                    specialty: specialty
                }).then(doctors=>{
                    this.doctorsToShow = doctors.in_call
                    this.doctorsToShowCount = this.doctorsToShow.length;
                })
                break;
        }
    }

    getProviders() {
        this.providerService.get().then((providers) => {
            this.providers = providers
        });
    }

    getCountries(){
        this.countryService.getAll().then((countries) => {
          this.countries = countries;
        });
      }

    getSpecialties(){
        this.specialtiesService.getAll().then((specialties)=>{
            this.specialties=specialties
        });
    }

    changeViewState(param) : void {
        this.viewState = param;
        this.getData();
    }

    ladDoctorChange(event){
        this.getData();
    }

    onSelect(doctor: any): void {
        this.router.navigate([ '/doctor/' + doctor.id ]);
    }

}



// WEBPACK FOOTER //
// ./src/app/doctors/detail/doctor-status.component.ts